import stdreqLabels from 'assets/labels/stdreq'
// import moment from 'moment'
// import faker from 'faker'

export const mocker = {
  labels () {
    return {
      labels: stdreqLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 1
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        desc_codpos: '',
        numappl: '',
        codempid: '',
        namempe: '',
        desc_statappl: '',
        dtefoll: ''
      })
    }
    let treqest1Data = {
      numreqst: '',
      desc_codcomp: '',
      codemprq: '',
      desc_codemprq: '',
      dtereq: '',
      codempap: '',
      desc_codempap: '',
      dteaprov: '',
      codemprc: '',
      desc_codemprc: '',
      desc_codpos: '',
      desc_stareq: '',
      totreq: '',
      totqtyact: '',
      toava: '',
      desnote: ''
    }
    let treqest2Data = {
      codjob: '',
      desc_codjob: '',
      codempmt: '',
      desc_codempmt: '',
      qtydatrqyr: '',
      qtydatrqmh: '',
      qtyreq: '',
      qtyact: '',
      qtyava: '',
      amtincom: '',
      desnoffi: '',
      dtereqm: '',
      desc_codrearq: '',
      dteopen: '',
      dteclose: '',
      flgrecut: '',
      flgjob: '',
      desc_syncond: '',
      desnote: ''
    }

    return {
      treqest1: treqest1Data,
      treqest2: {
        total: 1,
        rows: [treqest2Data]
      },
      detail: {
        total: mockTotal,
        rows: mockRows
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/stdreq/mocker.js